/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_BinderInputs */



/**
* | output |
* | --- |
* | "We checked the binder. This page is missing." |
*
* @param {Error_Subtext_BinderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_binder = /** @type {((inputs?: Error_Subtext_BinderInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_BinderInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir haben im Ordner nachgesehen. Diese Seite fehlt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous avons vérifié le classeur. Cette page manque.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("我们翻遍了卡册，这一页不见了。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("我們翻過卡冊了，找不到這一頁。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("바인더를 확인했지만 이 페이지가 없습니다.")
	return /** @type {LocalizedString} */ ("We checked the binder. This page is missing.")
});